module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab13/awsop-lab13.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab13/awsop-lab13.component.css
// module chunks = main